'use client'

import { useMutation } from "@tanstack/react-query"
import { API_Error } from "@/interfaces/api/response/api_response_types"
import { API_Data_Launch_Game_Response, LaunchGameData } from "@/interfaces/api/games/api_request_types"
import { launchGame } from "../requests/profiles"

export const useLaunchGame = () => useMutation<API_Data_Launch_Game_Response, API_Error, { profileId: string, payload: LaunchGameData }>({
    retry: false,
    mutationFn: launchGame
})